import { Controller } from "@hotwired/stimulus"

// data-controller="onboarding--likert-scale"
// targets: input (radio buttons), label (wrappers)
// action: change->onboarding--likert-scale#select
export default class extends Controller {
  static targets = ["input", "label"]

  select(event) {
    const selectedValue = event.currentTarget.value
    this.labelTargets.forEach((label) => {
      const input = label.querySelector("input[type='radio']")
      if (!input) return
      const isSelected = input.value === selectedValue
      label.classList.toggle("font-semibold", isSelected)
      label.classList.toggle("text-blue-700", isSelected)
    })
  }
}
